<template>
  <div class="wrapper p-5">
    <div
      v-for="(download, index) in downloads"
      :key="'links_' + index"
      :ref="'links_' + index"
      class="item d-flex py-4 px-5 align-items-center justify-content-between"
      data-cy="download-item"
      @click="onDownload(download)"
    >
      <div>{{ download.label }}</div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="#cc0033"
        class="bi bi-arrow-down"
        viewBox="0 0 16 16"
      >
        <path
          fill-rule="evenodd"
          d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
        />
      </svg>
    </div>
  </div>
</template>

<script>
/**
 * Affiche une liste de lien téléchargeable
 * Un bouton par défaut
 */
export default {
  name: 'SlDownloads',
  props: {
    // une tableau d'objet {label, link}
    downloads: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  setup() {
    const onDownload = (download) => {
      console.debug('[SlDownloads]', 'onDownload', 'download', JSON.stringify(download))
      window.open(download.link, "_blank");  
    }

    return {
      onDownload
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "src/scss/variables.scss";
  .wrapper{
    background-color: $background;

    .item {
      background-color: white;
      border-bottom: 0.063rem solid $background;
      cursor: pointer;
    }
  }
</style>
